import React, { useEffect, useCallback } from 'react';
import { Breadcrumbs } from 'kangarootime-ui';
import { connect } from 'react-redux';
import actions from '../duck/actions';
import EmployeeTimecards from '../EmployeeTimecards';
import NavigationBars from '../../../../components/HOC/withNavigationBars';
import './EmployeeAttendanceToday.css';

const EmployeeAttendance = ({
  todayTimecardsByEmployee,
  fetchingTimecards,
  ...props
}) => {
  // effects
  useEffect(() => {
    props.fetchTimecards();
  }, []);
  // end of effects

  const selectEmployee = useCallback(employee => {
    props.history.push(`/attendance/employee/${employee.employeeId}`, { employee });
  }, []);

  return (
    <NavigationBars>
      <div className='flex-columns flex-1'>
        <Breadcrumbs
          breadcrumbs={[
            { label: 'Attendance', link: null },
            { label: 'Employee', link: null }
          ]}
        />
        <div className='employee-attendance-container'>
          <EmployeeTimecards
            byEmployee={todayTimecardsByEmployee}
            loading={fetchingTimecards}
            onRowSelect={selectEmployee}
          />
        </div>
      </div>
    </NavigationBars>
  );
};

EmployeeAttendance.propTypes = {

};

// no redux hooks :(
const mapStateToProps = state => {
  return {
    todayTimecardsByEmployee: state.attendance.employee.today.byEmployee,
    fetchingTimecards: state.attendance.employee.meta.fetchingTimecards
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchTimecards: () => dispatch(actions.getCenterTimecards())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeAttendance);
